export class Noticia {
    constructor(
        public IdNoticia?: number,
        public titulo?: string,
        public cuerpo?: string,
        public mostrarWeb: boolean = false,
        public fechaAlta?: string,
        public fechaNoticia?: string
    ) { }
}